import React from "react";

import { Skeleton } from "@material-ui/lab";

import { Box } from "@material-ui/core";

const ViewLessonModalSkeleton: React.FC = () => (
  <Box data-test={"instructor-details-modal-skeleton"}>
    {[...Array(6)].map((_, idx) => (
      <Skeleton key={idx} width="50%" height="60px" />
    ))}
  </Box>
);

export default ViewLessonModalSkeleton;
